module.exports = __webpack_public_path__ + "static/assets/a308d7a16c4b10c1229f4401d0a12b31.png";